module.exports = __webpack_public_path__ + "static/img/visa-2.deeae83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/visa/visa-2.png
// module id = 263
// module chunks = 6